import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = axios.create({ baseURL: `${BASE}/api`, withCredentials: true });

API.interceptors.request.use((cfg) => {
  // Legacy: Authorization header from localStorage (kept for backward compat).
  // Primary auth transport is now the httpOnly cookie sent automatically by the browser.
  const token = localStorage.getItem("dmr_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

API.interceptors.response.use((r) => r, (err) => {
  if (err.response?.status === 401 && !err.config?.url?.includes("/auth/login")) {
    localStorage.removeItem("dmr_token");
    localStorage.removeItem("dmr_user");
    // Don't force-redirect if we're on a public/unauth page (landing, share invite, oauth callback)
    const PUBLIC_PATHS = ["/login", "/bagikan-undangan"];
    const path = window.location.pathname;
    if (!PUBLIC_PATHS.includes(path)) window.location.href = "/login";
  }
  return Promise.reject(err);
});

export const authAPI = {
  login: (email, password) => API.post("/auth/login", { email, password }).then((r) => r.data),
  logout: () => API.post("/auth/logout").then((r) => r.data),
  me: () => API.get("/auth/me").then((r) => r.data),
};
export const settingsAPI = {
  get: () => API.get("/settings").then((r) => r.data),
  update: (data) => API.put("/settings", data).then((r) => r.data),
};
export const usersAPI = {
  list: () => API.get("/users").then((r) => r.data),
  create: (data) => API.post("/users", data).then((r) => r.data),
  update: (id, data) => API.put(`/users/${id}`, data).then((r) => r.data),
  remove: (id) => API.delete(`/users/${id}`).then((r) => r.data),
};
export const pengumumanAPI = {
  list: () => API.get("/pengumuman").then((r) => r.data),
  create: (data) => API.post("/pengumuman", data).then((r) => r.data),
  update: (id, data) => API.put(`/pengumuman/${id}`, data).then((r) => r.data),
  remove: (id) => API.delete(`/pengumuman/${id}`).then((r) => r.data),
};
export const petugasLayananAPI = {
  list: (jenis) => API.get("/petugas-layanan", { params: jenis ? { jenis } : {} }).then((r) => r.data),
  create: (d) => API.post("/petugas-layanan", d).then((r) => r.data),
  update: (id, d) => API.put(`/petugas-layanan/${id}`, d).then((r) => r.data),
  remove: (id) => API.delete(`/petugas-layanan/${id}`).then((r) => r.data),
};
export const absensiLayananAPI = {
  list: (params) => API.get("/absensi-layanan", { params }).then((r) => r.data),
  create: (d) => API.post("/absensi-layanan", d).then((r) => r.data),
  remove: (id) => API.delete(`/absensi-layanan/${id}`).then((r) => r.data),
};
export const iuranAPI = {
  list: (params) => API.get("/iuran", { params }).then((r) => r.data),
  create: (data) => API.post("/iuran", data).then((r) => r.data),
  update: (id, data) => API.put(`/iuran/${id}`, data).then((r) => r.data),
  remove: (id) => API.delete(`/iuran/${id}`).then((r) => r.data),
  generate: () => API.post("/iuran/generate").then((r) => r.data),
  syncFromKas: () => API.post("/iuran/sync-from-kas").then((r) => r.data),
};
export const reminderAPI = {
  // WA reminder feature dihapus - stub kosong untuk backward compat
};
export const jadwalTamanAPI = {
  list: (petugas_id) => API.get("/jadwal-taman", { params: petugas_id ? { petugas_id } : {} }).then((r) => r.data),
  generate: (data) => API.post("/jadwal-taman/generate", data).then((r) => r.data),
  update: (id, data) => API.put(`/jadwal-taman/${id}`, data).then((r) => r.data),
  remove: (id) => API.delete(`/jadwal-taman/${id}`).then((r) => r.data),
  clear: (petugas_id) => API.delete(`/jadwal-taman/petugas/${petugas_id}`).then((r) => r.data),
  rekap: (petugas_id) => API.get(`/jadwal-taman/rekap/${petugas_id}`).then((r) => r.data),
  libur: (id) => API.post(`/jadwal-taman/${id}/libur`).then((r) => r.data),
  tambahHari: (data) => API.post("/jadwal-taman/tambah-hari", data).then((r) => r.data),
  lanjutkan: (data) => API.post("/jadwal-taman/lanjutkan", data).then((r) => r.data),
};
export const blokAPI = { list: () => API.get("/blok").then((r) => r.data) };
export const laporanKegiatanAPI = {
  list: (params) => API.get("/laporan-kegiatan", { params }).then((r) => r.data),
  add: (data) => API.post("/laporan-kegiatan", data).then((r) => r.data),
  update: (id, data) => API.put(`/laporan-kegiatan/${id}`, data).then((r) => r.data),
  remove: (id) => API.delete(`/laporan-kegiatan/${id}`).then((r) => r.data),
};
export const satpamPayrollAPI = {
  get: (bulan) => API.get("/jadwal-satpam/payroll", { params: { bulan } }).then((r) => r.data),
};
export const kasbonSatpamAPI = {
  list: (bulan) => API.get("/kasbon-satpam", { params: { bulan } }).then((r) => r.data),
  add: (data) => API.post("/kasbon-satpam", data).then((r) => r.data),
  remove: (id) => API.delete(`/kasbon-satpam/${id}`).then((r) => r.data),
};
export const kasAPI = {
  get: (bulan) => API.get("/kas", { params: bulan ? { bulan } : {} }).then((r) => r.data),
  addTx: (data) => API.post("/kas/transaksi", data).then((r) => r.data),
  updateTx: (id, data) => API.put(`/kas/transaksi/${id}`, data).then((r) => r.data),
  deleteTx: (id) => API.delete(`/kas/transaksi/${id}`).then((r) => r.data),
};
export const laporanAPI = {
  list: () => API.get("/laporan").then((r) => r.data),
  create: (data) => API.post("/laporan", data).then((r) => r.data),
  update: (id, data) => API.put(`/laporan/${id}`, data).then((r) => r.data),
};
export const kegiatanAPI = { list: () => API.get("/kegiatan").then((r) => r.data), create: (d) => API.post("/kegiatan", d).then((r) => r.data), update: (id, d) => API.put(`/kegiatan/${id}`, d).then((r) => r.data), remove: (id) => API.delete(`/kegiatan/${id}`).then((r) => r.data) };
export const sponsorAPI = { list: () => API.get("/sponsors").then((r) => r.data), create: (d) => API.post("/sponsors", d).then((r) => r.data), update: (id, d) => API.put(`/sponsors/${id}`, d).then((r) => r.data), remove: (id) => API.delete(`/sponsors/${id}`).then((r) => r.data) };
export const suratAPI = { list: () => API.get("/surat").then((r) => r.data), create: (d) => API.post("/surat", d).then((r) => r.data), update: (id, d) => API.put(`/surat/${id}`, d).then((r) => r.data) };
export const kontakAPI = { list: () => API.get("/kontak").then((r) => r.data), create: (d) => API.post("/kontak", d).then((r) => r.data), update: (id, d) => API.put(`/kontak/${id}`, d).then((r) => r.data), remove: (id) => API.delete(`/kontak/${id}`).then((r) => r.data) };
export const galeriAPI = { list: () => API.get("/galeri").then((r) => r.data), create: (d) => API.post("/galeri", d).then((r) => r.data), update: (id, d) => API.put(`/galeri/${id}`, d).then((r) => r.data), remove: (id) => API.delete(`/galeri/${id}`).then((r) => r.data) };
export const umkmAPI = { list: () => API.get("/umkm").then((r) => r.data), create: (d) => API.post("/umkm", d).then((r) => r.data), update: (id, d) => API.put(`/umkm/${id}`, d).then((r) => r.data), remove: (id) => API.delete(`/umkm/${id}`).then((r) => r.data) };
export const wargaInfoAPI = { list: () => API.get("/warga-info").then((r) => r.data), upsert: (d) => API.post("/warga-info", d).then((r) => r.data), update: (id, d) => API.put(`/warga-info/${id}`, d).then((r) => r.data), remove: (id) => API.delete(`/warga-info/${id}`).then((r) => r.data) };
export const publicAPI = { summary: () => API.get("/public/summary").then((r) => r.data) };
export const satpamPersonelAPI = {
  list: () => API.get("/satpam/personel").then((r) => r.data),
  create: (d) => API.post("/satpam/personel", d).then((r) => r.data),
  update: (id, d) => API.put(`/satpam/personel/${id}`, d).then((r) => r.data),
  remove: (id) => API.delete(`/satpam/personel/${id}`).then((r) => r.data),
};
export const kasChartAPI = { get: (bulan) => API.get("/kas/chart", { params: bulan ? { bulan } : {} }).then((r) => r.data) };
export const satpamAPI = {
  groups: () => API.get("/satpam/groups").then((r) => r.data),
  list: (bulan) => API.get("/jadwal-satpam", { params: bulan ? { bulan } : {} }).then((r) => r.data),
  update: (id, data) => API.put(`/jadwal-satpam/${id}`, data).then((r) => r.data),
  generate: () => API.post("/jadwal-satpam/generate").then((r) => r.data),
};
